import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import SelectComponent from "../Common/form-component/SelectComponent";
import ReactModal from "../Common/ReactModal";
import SimpleReactValidator from "simple-react-validator";
import {
  getCategoryManagementListQuery,
  copyFolderFromSourceToTarget,
  getSubcategoryListQuery,
} from "../../services/graphql/queries/category-management";
import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../miscellaneous/react-toastify";
import { SET_TIMEOUT_VALUE } from "../../constants/app-constants";

class FolderCopy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      projectOptions: [],
      subFolders: [],
      sourceProject: null,
      targetProject: null,
      copyModalVisible: false,
      successModalVisible: false,
      modalMessage: "",
      requireCancel: true,
      goBtnVisible: false,
      showSuccessMsg: false,
      CopySuccessMessage: "",
      copySuccessVisible: false,
      targetProjectError: "",
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: (message) => <div style={{ color: "red" }}>{message}</div>,
    });
    this.handleInput = this.handleInput.bind(this);
    this.submitModal = this.submitModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.copyModal = this.copyModal.bind(this);
  }

  getListOfCategory() {
    this.props.client
      .query({
        query: getCategoryManagementListQuery,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category = result.data.getListOfCategories;
        this.initialState = {
          projectOptions: category,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  checkIfProjectHasFolders(projectId) {
    this.props.client
      .query({
        query: getSubcategoryListQuery,
        variables: {
          referenceId: projectId,
          categoryId: parseInt(this.state.targetProject.id),
          subcategoryLevel: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var subcategories = result.data.getListOfSubcategories;
        // subcategories = subcategories.sort((a,b)=>this.compare(a,b));

        this.initialState = {
          subFolders: subcategories,
        };
        this.setState({
          ...this.initialState,
          loading: false,
          error: "",
        });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount() {
    this.setState({
      loading: false,
    });
    this.getListOfCategory();
  }

  folderCopyModalVisible() {
    if (this.validator.allValid()) {
      this.setState({
        copyModalVisible: !this.state.copyModalVisible,
        modalMessage:
          "Do you want to copy the folder? This action cannot be undone.",
      });
    } else {
      this.validator.showMessages();
    }
  }

  handleInput = (name, value) => {
    const selectedProject = this.state.projectOptions.find(
      (project) => project.id === Number(value)
    );

    this.setState(
      {
        [name]: selectedProject || null,
        error: "",
        targetProjectError:
          name === "sourceProject" ? "" : this.state.targetProjectError, // Clear error when source project is selected
      },
      () => {
        if (name === "targetProject") {
          this.checkIfProjectHasFolders(selectedProject.id);
        }
        this.setState({
          goBtnVisible:
            this.state.sourceProject != null &&
            this.state.targetProject != null,
        });
      }
    );
  };

  submitModal() {
    // this.setState({ copyModalVisible: false });

    this.props.client
      .query({
        query: copyFolderFromSourceToTarget,
        variables: {
          sourceCategoryId: this.state.sourceProject.id,
          targetCategoryId: this.state.targetProject.id,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // successMsg("Folder Structure Copied Successfullly")
        this.setState(
          {
            copyModalVisible: false,
            copySuccessVisible: true,
            CopySuccessMessage: "Copy Successfully",
            projectOptions: [],
            sourceProject: null,
            targetProject: null,
            goBtnVisible: false,
            //showSuccessMsg: true,
          },
          () => {
            // Refetch the project list
            this.getListOfCategory();
          }
        );
        setTimeout(() => {
          this.setState({ showSuccessMsg: false });
        }, 3000);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.closeModal();
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  closeModal() {
    this.setState({ copyModalVisible: false });
  }
  copyModal() {
    this.setState({ copySuccessVisible: false });
  }

  renderProjectDetailsTable = (project) => {
    if (!project) return null;

    return (
     
      <div
        className="p-2"
        style={{
          display: "grid",
          gridTemplateColumns: "max-content 1fr", // Labels stay in one column, values in another
          gap: "18px 35px", // Spacing between rows and columns
          fontSize: "17px",
          //width: "100%",
          wordWrap: "break-word",
        }}
      >
        <strong>Project ID:</strong>
        <div>
          <span>{project.projectId}</span>
        </div>

        <strong>Project Name:</strong>
        <div>
          <span>{project.name}</span>
        </div>

        <strong>Manager:</strong>
        <div>
          <span>{project.manager}</span>
        </div>

        <strong>Client:</strong>
        <div>
          <span>{project.client}</span>
        </div>

        <strong>Description:</strong>
        <div>
          <span>{project.description}</span>
        </div>
      </div>
    );
  };

  render() {
    const {
      loading,
      error,
      sourceProject,
      targetProject,
      copyModalVisible,
      modalMessage,
      requireCancel,
      goBtnVisible,
      projectOptions,
      subFolders,
      CopySuccessMessage,
      copySuccessVisible,
    } = this.state;

    

    const activeProjectOptions = projectOptions;
    let targetProjectOptions = projectOptions;

    if (this.state.sourceProject) {
      targetProjectOptions = projectOptions.filter(
        (project) => project?.id !== this.state.sourceProject?.id
      );
    }

    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <div>
        <ReactModal
          reactModalVisible={copyModalVisible}
          modalMessage={modalMessage}
          submitModal={this.submitModal}
          requireCancel={requireCancel}
          closeModal={this.closeModal}
        />
        <ReactModal
          reactModalVisible={copySuccessVisible}
          modalMessage={CopySuccessMessage}
          submitModal={this.copyModal}
        />

        <div className="row  no-gutters">
          <div className="col-md-8">
            <h1 className="heading m-b-0">Folder Copy </h1>
          </div>
          <div className="col-md-4 text-right"></div>
        </div>
        <div className="row  mt-5">
          <div className="col-md-6">
          <div className="source-container">
              <div className="target-name">
              <label
                  className=""
                  style={{
                    fontWeight: "600",
                  }}
                >
                  SOURCE PROJECT
                  <span style={{ color: "red"}}>*</span>
                  <span>
                    :
                  </span>
                </label>
              </div>
              <div className="target-dropdown">
              <SelectComponent
                    required
                    // label={"Source Project"}
                    title={"sourceProject"}
                    name={"sourceProject"}
                    options={activeProjectOptions.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}]  ${project.name}`,
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    value={sourceProject?.id || ""}
                    placeholder={"Select Source Project"}
                    handleChange={(e) =>
                      this.handleInput("sourceProject", e.target.value)
                    }
                    validator={this.validator}
                    validation="required"
                  />
              </div>
              

            </div>
            <div
                  className="source-space"
                  style={{
                    color: "red",
                    fontSize: "14px",
                   // visibility: subFolders.length > 0 ? "visible" : "hidden",
                  }}
                >
                  
                </div>
            <div className="source-box">
              {/* <div className="col-md-4"></div> */}
              <div
                className="border bg-light p-3 mt-1"
                style={{
                  minHeight: "16rem",
                }}
              >
               {sourceProject ? (
                  this.renderProjectDetailsTable(sourceProject)
                ) : (
                  <p
                    className="text-muted"
                    style={{ textAlign: "center", fontSize: "15px" }}
                  >
                    No Source Project Selected
                  </p>
                )}
              </div>
            </div>
            
          </div>
          <div className="col-md-6 bg-succes p-0 m-0">
            <div className="target-container">
              <div className="target-name">
              <label
                  className=""
                  style={{
                    fontWeight: "600",
                  }}
                >
                  TARGET PROJECT
                  <span style={{ color: "red"}}>*</span>
                  <span>
                    :
                  </span>
                </label>
              </div>
              <div className="target-dropdown">
              <SelectComponent
                    required
                    title={"targetProject"}
                    name={"targetProject"}
                    options={targetProjectOptions.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}] ${project.name}`,
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    value={targetProject?.id || ""}
                    placeholder={"Select Target Project"}
                    handleChange={(e) =>
                      this.handleInput("targetProject", e.target.value)
                    }
                    validator={this.validator}
                    validation="required"
                    disabled={!this.state.sourceProject}
                  />
              </div>
            </div>
            <div
                  className="target-alert"
                  style={{
                    color: "red",
                    fontSize: "16px",
                    visibility: subFolders.length > 0 ? "visible" : "hidden",
                  }}
                >
                  Please select a project without folders.
                </div>
           
            <div className="target-box">
              
              <div
                className=" border bg-light p-3"
                style={{
                  minHeight: "16rem",
                }}
              >
                {targetProject ? (
                  this.renderProjectDetailsTable(targetProject)
                ) : (
                  <p
                    className="text-muted"
                    style={{ textAlign: "center", fontSize: "15px" }}
                  >
                    No Target Project Selected
                  </p>
                )}
              </div>
            </div>
            
          </div>

          {/* <div className="col-sm-6">
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-3 p-0">
                <label
                  className="pt-4 pb-4"
                  style={{
                    fontWeight: "600",
                    width: "100%",
                   
                  }}
                >
                  SOURCE PROJECT
                  <span style={{ color: "red"}}>*</span>
                  <span>
                    :
                  </span>
                </label>
              </div>
              <div className="col-5  p-0">
                <div className="pt-3">
                  <SelectComponent
                    required
                    // label={"Source Project"}
                    title={"sourceProject"}
                    name={"sourceProject"}
                    options={activeProjectOptions.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}]  ${project.name}`,
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    value={sourceProject?.id || ""}
                    placeholder={"Select Source Project"}
                    handleChange={(e) =>
                      this.handleInput("sourceProject", e.target.value)
                    }
                    validator={this.validator}
                    validation="required"
                  />
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>
            <div className="row mt-3 p-0">
              <div className="col-md-4"></div>
              <div
                className="col-md-7 border bg-light p-3 mt-1"
                style={{
                  minHeight: "16rem",
                }}
              >
                {sourceProject ? (
                  this.renderProjectDetailsTable(sourceProject)
                ) : (
                  <p
                    className="text-muted"
                    style={{ textAlign: "center", fontSize: "15px" }}
                  >
                    No Source Project Selected
                  </p>
                )}
              </div>
            </div>
          </div> */}

          {/* <div className="col-sm-6">
            <div className="row">
              {this.state.error && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    marginBottom: "5px",
                  }}
                >
                  {this.state.error}
                </div>
              )}
              <div className="col-sm-3  p-0 bg-info">
                <label className="pt-4 pb-4" style={{ fontWeight: "600",}}>
                  TARGET PROJECT
                  <span style={{ color: "red", fontSize: "" }}>*</span>
                  <span className="" style={{ color: "" }}>
                    :
                  </span>
                </label>
              </div>
              <div className=" col-sm-6  p-0 bg-primary">
                <div className="pt-3">
                  <SelectComponent
                    required
                    title={"targetProject"}
                    name={"targetProject"}
                    options={targetProjectOptions.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}] ${project.name}`,
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    value={targetProject?.id || ""}
                    placeholder={"Select Target Project"}
                    handleChange={(e) =>
                      this.handleInput("targetProject", e.target.value)
                    }
                    validator={this.validator}
                    validation="required"
                    disabled={!this.state.sourceProject}
                  />
                </div>
                <div
                  className=""
                  style={{
                    color: "red",
                    fontSize: "14px",
                    visibility: subFolders.length > 0 ? "visible" : "hidden",
                  }}
                >
                  Please select a project without folders.
                </div>
              </div>
            </div>
            <div className="row">
              
              <div
                className="col-sm-9 border bg-success p-3"
                style={{
                  width: "30%",
                  minHeight: "16rem",
                }}
              >
                {targetProject ? (
                  this.renderProjectDetailsTable(targetProject)
                ) : (
                  <p
                    className="text-muted"
                    style={{ textAlign: "center", fontSize: "15px" }}
                  >
                    No Target Project Selected
                  </p>
                )}
              </div>
            </div>
          </div> */}

          <div className="col-12 d-md-flex justify-content-md-center align-items-center mt-5 ml-">
            <button
              type="button"
              className={`btn ${
                goBtnVisible && subFolders.length === 0
                  ? "btn-danger"
                  : "btn-secondary"
              }`}
              onClick={() => this.folderCopyModalVisible()}
              disabled={!goBtnVisible || subFolders.length > 0}
            >
              Go
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withApollo(FolderCopy));
